<template>
  <div class="upload_image">
    <div class="__upload-image" v-loading="isLoading">
      <el-image ref="img" :src="'/api'+value" fit="cover" :preview-src-list="['/api'+value]">
        <!-- <el-image ref="img" :src="require('./logo.png')" :preview-src-list="[require('./logo.png')]"> -->
        <div slot="error" class="error_img">
          <i class="el-icon-user"></i>
        </div>
      </el-image>
      <div class="__image-buttons" v-if="value">
        <i class="el-icon-zoom-in" @click="onPreview"></i>
        <el-popconfirm title="确定删除吗？" v-if="showDel" @onConfirm="onDelete">
          <i class="el-icon-delete" slot="reference" style="margin-left:10px"></i>
        </el-popconfirm>
      </div>
    </div>
    <div class="upload_btn" :style="isMB?'margin: 15px 0 10px':''">
      <el-upload
        v-show="!isMB"
        :headers="header"
        :action="uploadUrl"
        :on-success="onUploadSuccess"
        :show-file-list="false"
        :data="data"
      >
        <el-button size="mini" style="width: 130px;" type="primary" icon="el-icon-upload2">上传照片</el-button>
      </el-upload>
    </div>
  </div>
</template>
<script>
import api from "@/api/common/common";
export default {
  props: {
    value: {
      type: String,
      default: undefined,
    },
    uploadUrl: {
      type: String,
      default: api.uploadPictureUrl,
    },
    deleteFunc: {
      type: Function,
      default: api.deletePhoto,
    },
    type: {
      type: String,
      default: undefined,
    },
    data: {
      type: Object,
      default: null,
    },
    showDel: {
      type: Boolean,
      default: true,
    },
    IsDetail: {
      type: Boolean,
      default: false,
    },
    tip: {
      type: String,
      default: "",
    },
  },
  watch: {
    // value(nv) {
    //   this.Lvalue = nv;
    // },
  },
  data() {
    return {
      isLoading: false,
      isMB: this.$store.state.isMB,
      // Lvalue: "",
    };
  },
  computed: {
    // fileList() {
    //   if (!this.Lvalue) return [];
    //   return [
    //     {
    //       url: this.Lvalue,
    //     },
    //   ];
    // },
    header() {
      let token = localStorage.getItem("token");
      if (token) {
        return { Authorization: "Bearer " + token };
      }
      return {};
    },
  },
  methods: {
    onUploadSuccess(res, file, fileList) {
      // console.log(res);
      this.$emit("input", "" + res.Data);
    },
    onDelete() {
      this.$emit("input", "");
      // this.isLoading = true;
      // this.deleteFunc(this.value).then((res) => {
      //   this.isLoading = false;
      //   if (res.Code == 0) {
      //     this.$emit("input", "");
      //   } else {
      //     this.$message.error(res.Msg);
      //   }
      // });
      // this.Lvalue = "";
      // this.$emit("delLogo");
    },
    onPreview() {
      this.$refs.img.clickHandler();
    },
  },
};
</script>

<style lang="scss">
.upload_image {
  width: 100%;
  .__upload-area {
    border: 1px dashed #c0ccda;
    // border-radius: 6px;
    box-sizing: border-box;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    line-height: 120px;
    width: 120px;
    height: 120px;
    font-size: 32px;
    color: #8c939d;
  }
  .__upload-area:hover {
    border-color: #409eff;
  }
  .__upload-image {
    border: 1px solid #c0ccda;
    overflow: hidden;
    width: 130px;
    height: 165px;
    margin: auto;
    position: relative;
    .el-image {
      width: 100%;
      height: 100%;
      // object-fit: cover;
    }
    .error_img {
      font-size: 96px;
      text-align: center;
      padding-top: 23px;
      color: #959595;
    }
    .__image-buttons {
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      bottom: 0;
      opacity: 0;
      background: rgba(0, 0, 0, 0.5);
      line-height: 165px;
      color: #ffffff;
      transition: opacity 0.3s;
      text-align: center;
      i {
        font-size: 18px;
        cursor: pointer;
      }
      i + i {
        margin-left: 10px;
      }
    }
    .__image-buttons:hover {
      opacity: 1;
    }
  }
}

.upload_btn {
  width: 100%;
  text-align: center;
  margin-top: 24px;
}

// .__single-photo-upload {
//   display: flex;

// }
</style>